/**
 * Telegram Mini App wrapper for the Aptitude drill review page.
 * URL: /tg/aptitude-drill/review/:sessionId
 */

import React from 'react';
import TelegramShell from '../components/TelegramShell';
import AptitudeReview from './AptitudeReview';

const TelegramAptitudeReview: React.FC = () => (
  <TelegramShell>
    <AptitudeReview />
  </TelegramShell>
);

export default TelegramAptitudeReview;
